import axios from "./axios-auth";

const getPointsRemainingByUnitData = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/hr-adm/getpointsremaingbyunitdata",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error while getting remaing points by unit data");
      });
  });

export { getPointsRemainingByUnitData };
